import   axios                                              from 'axios';

import { retrieveUserList                           ,
         retrieveUserById                           } from '../../store/userManagment/actions';
import { retrieveDetailledIpAddressInformations     ,
         retrieveDetailledIpAddressInformationsByIp } from '../../store/networkManagment/actions';
import { retrieveMediaById                          ,
         retrieveMediaList                          } from '../../store/mediaManagment/actions';

import { BackendResponse                            ,
         handleError                                }  from '../../dataTypes/backendServicesManagment/types';

import { CustomerFrontEvent                         ,
         initializedCustomerFrontEvent              ,
         EnrichedCustomerFrontEvent                 ,
         initializedEnrichedCustomerFrontEvent      ,
         GetCustomerFrontEventParams                } from '../../dataTypes/customerFrontEventManagment/types';

import { extractVideoId                             } from '../../dataTypes/customerFrontEventManagment/utils';


import { HeartBeatCountData, Coordinate             } from '../../dataTypes/geolocationManagment/types';

import { API_URLS                                   } from '../urls';

export interface BackendResponse_CustomerFrontEventList extends BackendResponse<CustomerFrontEvent[]> {}

export const getCustomerFrontEvents = async ( params: GetCustomerFrontEventParams = {} ): Promise<BackendResponse_CustomerFrontEventList> => {

  const url = API_URLS.getCustomerFrontEvents;
  const queryParams = new URLSearchParams();

  if ( params.userEmail            ) queryParams.append ( 'userEmail'        , params.userEmail                            );
  if ( params.userId !== undefined ) queryParams.append ( 'userId'           , params.userId.toString()                    );
  if ( params.ipAddress            ) queryParams.append ( 'ipAddress'        , params.ipAddress                            );
  if ( params.eventFragment        ) queryParams.append ( 'eventFragment'    , params.eventFragment                        );
  
  /*
   if ( params.beginningDate        ) queryParams.append ( 'beginningDateStr' , convertDateToString ( params.beginningDate) );
   if ( params.endingDate           ) queryParams.append ( 'endingDateStr'    , convertDateToString ( params.endingDate)    );
  */
  
  
   if (params.beginningDate) 
    {
//     const utcDate = new Date(params.beginningDate);
     const utcDate = new Date(params.beginningDate.toISOString());
     const formattedUTCDate = utcDate.toISOString().replace(/T/, ' ').replace(/\..+/, '').replace(/-/g, '/');


     queryParams.append('beginningDateStr', formattedUTCDate);
    }

   if (params.endingDate) 
    {
//     const utcDate = new Date(params.endingDate);
     const utcDate = new Date(params.endingDate.toISOString());
     const formattedUTCDate = utcDate.toISOString().replace(/T/, ' ').replace(/\..+/, '').replace(/-/g, '/');

     queryParams.append('endingDateStr', formattedUTCDate);
    }
  
  const fullUrl = `${url}?${queryParams.toString()}`;

  try
   {
    const response = await axios.get(fullUrl);

    if (response.status === 200)
          {
           const defaultCustomerFrontEvent = initializedCustomerFrontEvent();

           const logs: CustomerFrontEvent[] = response.data.map((rawLog: any) => ({

              ...defaultCustomerFrontEvent,
              id                    :            rawLog?.id                      ?? defaultCustomerFrontEvent.id,
              userId                :            rawLog?.userId                  ?? defaultCustomerFrontEvent.userId,
              event                 :            rawLog?.event                   ?? defaultCustomerFrontEvent.event,
              eventDate             : new Date ( rawLog?.eventDate             ) ?? defaultCustomerFrontEvent.eventDate,
	   /*
	   eventDate: rawLog?.eventDate
  ? new Date(new Date(rawLog.eventDate).getTime() + new Date().getTimezoneOffset() * -60000)
  : defaultCustomerFrontEvent.eventDate,
	   */
              ipAddress             :            rawLog?.ipAddress               ?? defaultCustomerFrontEvent.ipAddress,
              userAgentInformations :            rawLog?.userAgentInformations   ?? defaultCustomerFrontEvent.userAgentInformations,
              appInformations       :            rawLog?.appInformations         ?? defaultCustomerFrontEvent.appInformations,
	          country               :            rawLog?.country                 ?? defaultCustomerFrontEvent.country,
              city                  :            rawLog?.city                    ?? defaultCustomerFrontEvent.city,
              lat                   :            rawLog?.lat                     ?? defaultCustomerFrontEvent.lat,
              lon                   :            rawLog?.lon                     ?? defaultCustomerFrontEvent.lon,
              isp                   :            rawLog?.isp                     ?? defaultCustomerFrontEvent.isp  
		   }));

           return {
             code    : 1,
             comment : 'The retrieval of logs is complete.',
             payload : logs,
            };
          }
     else {
           return handleError<CustomerFrontEvent[]>(response.status, 'Réponse non-200 de l\'API ou données invalides.');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<CustomerFrontEvent[]>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<CustomerFrontEvent[]>(-102, 'Unknown error');
   }
};


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface BackendResponse_EnrichedCustomerFrontEventList extends BackendResponse <EnrichedCustomerFrontEvent[]> {};

export const getEnrichedCustomerFrontEvents = async ( params: GetCustomerFrontEventParams = {} ): Promise<BackendResponse_EnrichedCustomerFrontEventList> => {

  await retrieveDetailledIpAddressInformations();
  await retrieveUserList(params);
  await retrieveMediaList();

  const customerFrontEvents = await getCustomerFrontEvents (params)


  //////////////////////

  const userIdSet    = new Set<number>();
  const ipAddressSet = new Set<string>();
  const mediaIdSet   = new Set<number>();
  
  customerFrontEvents.payload.forEach ( event => {
    userIdSet.add    (event.userId);
	ipAddressSet.add (event.ipAddress);
	mediaIdSet.add   (extractVideoId(event.event));
  });
  
  // Créer des objets pour stocker les résultats
const tabUser: { [key: number]: any } = {};
const tabIpAddress: { [key: string]: any } = {};
const tabMedia: { [key: number]: any } = {};

  // Remplir les objets avec les résultats des appels aux fonctions de récupération
  await Promise.all([
    ...Array.from(userIdSet)   .map(async (userId)    => { tabUser      [userId]    = await retrieveUserById(userId);                              }),
    ...Array.from(ipAddressSet).map(async (ipAddress) => { tabIpAddress [ipAddress] = await retrieveDetailledIpAddressInformationsByIp(ipAddress); }),
    ...Array.from(mediaIdSet)  .map(async (mediaId)   => { tabMedia     [mediaId]   = await retrieveMediaById(mediaId);                            }),
  ]);  
  
  /////////////////////
  
  const enrichedEvents = await Promise.all(customerFrontEvents.payload.map(async (event) => {

    const defaultEnrichedEvent = initializedEnrichedCustomerFrontEvent();

    // const user         = await retrieveUserById (event.userId) || null;
    // const ipDetails    = await retrieveDetailledIpAddressInformationsByIp (event.ipAddress, event.userId);
    // const mediaDetails = await retrieveMediaById (extractVideoId(event.event));
    // const isIpMismatch = user && event.ipAddress && user.creationIpAddress !== event.ipAddress;

  const userId = event.userId;
  const ipAddress = event.ipAddress;
  const mediaId = extractVideoId(event.event);

  const user = tabUser[userId] || null;
  const ipDetails = tabIpAddress[ipAddress];
  const mediaDetails = tabMedia[mediaId];
  const isIpMismatch = user && ipAddress && user.creationIpAddress !== ipAddress;
  
    return {
      ...defaultEnrichedEvent,
      id                    : event.id,
      userId                : event.userId,
      event                 : event.event,
      eventDate             : event.eventDate,
      ipAddress             : event.ipAddress,
      userAgentInformations : event.userAgentInformations,
      appInformations       : event.appInformations,
	  country               : event.country,
      city                  : event.city,
      lat                   : event.lat,
      lon                   : event.lon,
      isp                   : event.isp,  
      user,
      ipDetails,
      isIpMismatch,
      mediaDetails,
    };
  }));

  return {
    code    : 1,
    comment : 'Enriched events retrieval complete.',
    payload : enrichedEvents,
  };

};


export interface BackendResponse_HeartBeatCount extends BackendResponse<HeartBeatCountData> {}


// Fonction mise à jour
export const getHeartBeatCount = async ( dateStr?       : string           , 
                                         channelUuid?   : string           ,
                                         heartBeatType? : string           ,
                                         timeStep       : string = '1 day' ): Promise<BackendResponse_HeartBeatCount> => {
  const url = API_URLS.getHeartBeatCount;
  let paramStr: string = '';
  if ( dateStr       ) paramStr += `dateStr=${dateStr}`
  if ( channelUuid   ) paramStr += (paramStr != '' ? '&' : '') + `channelUuid=${channelUuid}`
  if ( heartBeatType ) paramStr += (paramStr != '' ? '&' : '') + `heartBeatType=${heartBeatType}`
  if ( timeStep      ) paramStr += (paramStr != '' ? '&' : '') + `timeStep=${timeStep}`
  const fullUrl = paramStr != '' ? `${url}?${paramStr}` : `${url}`;

  try
  {
    const response = await axios.get(fullUrl);

    if (response.status === 200)
    {
      const rawCoords: { ipAddress: string, lat: number, lon: number }[] = response.data.coordinates ?? [];

      const coordinates: Coordinate[] = rawCoords.map((row) => ({
        lat   : row.lat       ,
        lng   : row.lon       ,        // lon (backend) → lng (frontend)
        info1 : row.ipAddress ,
        info2 : ""            ,
        color : "#25C400"     ,
      }));

      return {
        code    : 1,
        comment : 'The retrieval of heartbeat data is complete.',
        payload : {
          ipCount     : response.data.ipCount ,
          coordinates : coordinates           ,
        },
      };
    }
    else
    {
      return handleError<HeartBeatCountData>(response.status, 'Réponse non-200 de l\'API ou données invalides.');
    }
  }
  catch (error)
  {
    if (axios.isAxiosError(error))
    {
      return handleError<HeartBeatCountData>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<HeartBeatCountData>(-102, 'Unknown error');
  }
};